export default "__VITE_ASSET__DY4mGbhM__"